import React, { Component } from 'react'

export class Footer extends Component {
    render() {
        let { count , sitename } = this.props;
        return (
            <footer >
                <div className="__container">
                    <div className="flex flex-col md:flex-row gap-y-3 md:justify-between">
                        <span className="text-xs md:text-sm md:order-2">
                            We've already converted <span>{count}</span> files.
                        </span>

                        <span className="text-xs md:text-sm  md:order-1">
                            Copyright © 2022<a href="#" className="ml-1">{sitename}</a>.
                            All rights reserved
                        </span>

                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer